export default __webpack_public_path__ + "static/media/servicio-drenaje.f95b011a.jpg";